module.exports = __webpack_public_path__ + "static/media/a-tale-for-the-time-being.6b7bc629.jpg";